import { EspacioCurricularI } from "interfaces/EspacioCurricular";
import { ReactNode } from "react";
import { Badge } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";
import { labelCursado } from "components/EspaciosTable/EspaciosTable";

interface Props {
  elemento: EspacioCurricularI;
  renderActions?: (elemento: EspacioCurricularI) => ReactNode;
}

export const EspaciosCurricularesRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`DiseñosCurricularesTable-${elemento.id}`}>
        <td>{elemento?.id}</td>
        <td>{elemento?.nombre}</td>
        <td>{elemento?.descripcion}</td>
        <td>{elemento?.area?.nombre}</td>
        <td>{elemento?.nivel?.nombre}</td>
        <td>
          {elemento?.ciclo?.nombre ? elemento?.ciclo?.nombre : "No asignado"}
        </td>
        <td>{labelCursado(elemento?.cuatrimestre)}</td>
        <td>{elemento?.tipo_espacio?.nombre}</td>
        <td>
          {elemento?.tipo_espacio?.con_sub_tipo ? elemento?.sub_tipo : "-"}
        </td>

        {renderActions && <td>{renderActions(elemento)}</td>}
      </tr>
    </>
  );
};
